import { useLocation, useNavigate } from 'react-router';

import { useHasPermissions } from '~domains/auth';

import { ROUTES } from '~shared/config/routes';
import { useIsDesktop } from '~shared/lib/responsive';
import { MobileSelect } from '~shared/ui/mobile-select';

import { Chips } from '@breezeventures/ui-kit/chips';

type TransactionsTab = 'loans' | 'payments';

export const TransactionsTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isDesktop = useIsDesktop();
  const { checkPermissions } = useHasPermissions();
  const showLoans = checkPermissions(['APPLICATIONS_VIEW']);
  const showPayments = checkPermissions(['TRANSACTIONS_VIEW']);

  const activeTab: TransactionsTab = pathname.startsWith(
    ROUTES.transactions.payments
  )
    ? 'payments'
    : 'loans';

  const handleChange = (value: string) => {
    navigate(
      value === 'payments'
        ? ROUTES.transactions.payments
        : ROUTES.transactions.loans
    );
  };

  if (!isDesktop) {
    const options: { value: TransactionsTab; label: string }[] = [
      ...(showLoans
        ? [{ value: 'loans' as const, label: 'Signed loans' }]
        : []),
      ...(showPayments
        ? [{ value: 'payments' as const, label: 'Payments' }]
        : []),
    ];

    return (
      <MobileSelect
        options={options}
        value={activeTab}
        onChange={handleChange}
      />
    );
  }

  return (
    <div role="tablist">
      <Chips
        type="single"
        variant="soft"
        size="m"
        value={activeTab}
        onChange={handleChange}
      >
        {showLoans && (
          <Chips.Item
            value="loans"
            role="tab"
            aria-selected={activeTab === 'loans'}
          >
            Signed loans
          </Chips.Item>
        )}

        {showPayments && (
          <Chips.Item
            value="payments"
            role="tab"
            aria-selected={activeTab === 'payments'}
          >
            Payments
          </Chips.Item>
        )}
      </Chips>
    </div>
  );
};
